import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { DefaultLanguage, LanguageKeys } from '@shared/constants/languages.constant';
import tr from './assets/primelocale/tr.json';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private primeng: PrimeNG,
  ) {
    this.translate.addLangs(LanguageKeys);
    this.translate.setDefaultLang(DefaultLanguage);
    this.translate.use(DefaultLanguage);
    this.initializeLanguage();
  }

  private initializeLanguage() {
    this.primeng.setTranslation(tr.tr);
  }
}
